
































































import Vue from 'vue'
import Component from 'vue-class-component'
import { Watch } from 'vue-property-decorator'
import { i18n } from '@/plugins/i18n'
import { namespace } from 'vuex-class'
import gsap from 'gsap'

import Gmaps from '@/components/Gmaps.vue'

const AppStore = namespace('AppStore')
const SnackbarStore = namespace('SnackbarStore')

@Component({
  components: {
    Gmaps,
  },
})
export default class Home extends Vue {
  @SnackbarStore.Mutation setSnackbarError!: (error: string) => void

  opacity = 0

  tweenedBattery = 1
  get battery() {
    let b = this.tweenedBattery.toFixed(0).toString()
    // update gradient position
    document
      .getElementById('b1')
      ?.style.setProperty(
        '--gradient-start',
        (this.tweenedBattery - 1).toFixed(5).toString() + '%'
      )
    document
      .getElementById('b1')
      ?.style.setProperty(
        '--gradient-end',
        this.tweenedBattery.toFixed(5).toString() + '%'
      )
    // update gradient color
    document
      .getElementById('b1')
      ?.style.setProperty(
        '--gradient-hue',
        this.tweenedBattery.toFixed(3).toString()
      )
    document
      .getElementById('b1')
      ?.style.setProperty(
        '--gradient-saturation',
        (90 - this.tweenedBattery / 5).toFixed(3).toString() + '%'
      )

    // return value
    if (b.length == 3) return b[0] + b[1] + ' ' + b[2] + ' '
    if (b.length == 1) return b[0] + ' '
    if (b.length > 1 && b[0] == '1') return b + ' '
    return b[0] + ' ' + b[1] + ' '
  }

  costPerkWh = 0.31 // $
  poundsPerkWh = 0.85 // pounds of CO2 saved
  get cost() {
    return (this.tweenedenergyDelivered * this.costPerkWh).toFixed(1)
  }

  get pounds() {
    return (this.tweenedenergyDelivered * this.poundsPerkWh).toFixed(1)
  }

  timestamp = 0
  deltaEnergyChange_ = 0
  deltaEnergyChange = 0

  minutesUntilFullCharge = 20

  tweenedenergyDelivered = 0
  get energyDelivered() {
    return this.tweenedenergyDelivered.toFixed(1)
  }

  mounted() {
    if (
      window.location.hash === '#rec422536037' ||
      window.location.pathname.includes('echarge') ||
      window.location.host === 'localhost:8080'
    )
      window.setTimeout(this.animate, 500)
  }

  animate() {
    // Set opcaity while animation is on
    window.setTimeout(() => {
      this.opacity = 1
    }, 500)

    // Update Sparkline
    window.setTimeout(() => {
      gsap.to(this.$data, { duration: 20, tweenedenergyDelivered: 60 })
      gsap.to(this.$data, { duration: 20, tweenedBattery: 100 })
    }, 1200)

    window.setInterval(() => {
      if (this.minutesUntilFullCharge <= 0) return
      this.minutesUntilFullCharge -= 1
    }, 1000)

    window.setInterval(() => {
      let to = this.deltaEnergyChange_
      gsap.to(this.$data, { duration: 0.45, deltaEnergyChange: to })
    }, 500)
  }

  get isWindowHashCorrect() {
    // return if the button at echarge has been clicked
    return window.location.hash === '#rec422536037'
  }

  @Watch('isWindowHashCorrect')
  onLoad(value: boolean) {
    if (!value) return

    window.setTimeout(this.animate, 500)
  }

  @Watch('tweenedenergyDelivered')
  onTweenedenergyDeliveredChange(value: number, oldValue: number) {
    this.deltaEnergyChange_ = (value - oldValue) / (Date.now() - this.timestamp)
    this.timestamp = Date.now()
  }
}
